import { Component, OnDestroy, OnInit } from '@angular/core';
import { ConfirmDismissDialogComponent } from 'app/modules/shared/components/confirm-dismiss-dialog/confirm-dismiss-dialog.component';
import { DataService, HelperService, HTTPService } from 'app/services';
import { DialogService } from 'primeng/dynamicdialog';

import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { debounceTime, Subject, Subscription } from 'rxjs';
import { round, find, lowerCase } from 'lodash';
import { formulationOptions, measureOptions, reorderOptions, viscosityOptions } from 'app/constants/partlookup.constants';

@Component({
  selector: 'app-engine-oil-dialog',
  templateUrl: './engine-oil-dialog.component.html',
  styleUrls: ['./engine-oil-dialog.component.scss'],
})
export class EngineOilDialogComponent implements OnInit, OnDestroy {
  ro: string = '';
  isFlatRateItem: boolean = false;
  title: string = '';
  engineOilDetails: any = {};
  // Synthetic Blend Synthetic, Semi-Synthetic, Conventional.
  formulationOptions: typeof formulationOptions = formulationOptions;
  viscosityOptions: typeof viscosityOptions = viscosityOptions;
  measureOptions: typeof measureOptions = measureOptions;

  fluidFilter: any = {};
  defaultRecommend: any = {};
  recommend: any = {};
  apiQuery: any = {};
  listData: any;
  noRecordFound: boolean = false;
  isProcessing: boolean = true;
  copiedIndex: number = -1;
  isProcessingAddingList: boolean = false;
  private quantityChangeSubject = new Subject<any>();
  serviceId: string = '';
  onSelectProcessing: boolean = false;
  disableInventoryOrder: boolean = true;
  selectedItem: any = {};
  // Conversion factors
  quartToLiter = 0.946353;
  literToQuart = 1.05669;
  defaultRecomandedUnit: string = '';
  recommendResultsNotFound: boolean = false;
  companyLocalizationSubscription: Subscription;
  currentLang = 'en';

  constructor(
    private dynamicDialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private helperService: HelperService,
    private httpService: HTTPService,
    public dialogService: DialogService,
    private dataService: DataService,
  ) {
    this.quantityChangeSubject
      .pipe(
        debounceTime(900), // Delay in milliseconds
      )
      .subscribe((quantity) => {
        // this.apiQuery.quantity = quantity;
        this.getList();
      });
  }

  ngOnInit() {
    this.defaultRecommend = {
      formulation: 'Full Synthetic',
      qty: '4.4',
      unit: this.dataService.isCountryCanada ? 'Litres' : 'Quarts',
      viscosity: '0W-16',
    };
    const { engineOilDetails, isFlatRateSubItem, title, getDatalistAPIPayload, serviceId, estimateId, currentLang } = this.dynamicDialogConfig.data;
    this.currentLang = currentLang;
    this.serviceId = serviceId;
    this.isFlatRateItem = isFlatRateSubItem;
    this.title = title;

    this.httpService.getEstimateById(estimateId).then(({ code }) => {
      this.ro = code;
    });

    if (engineOilDetails?.specs) {
      this.engineOilDetails = engineOilDetails?.specs;

      if (this.engineOilDetails?.recommend?.unit) {
        this.engineOilDetails.recommend.unit = this.engineOilDetails.recommend.unit + 's';
      }
      if (this.engineOilDetails?.recommend?.formulation) {
        this.formulationOptions = reorderOptions(this.formulationOptions, this.engineOilDetails?.recommend?.formulation);
      }
      if (this.engineOilDetails?.recommend?.viscosity) {
        this.viscosityOptions = reorderOptions(this.viscosityOptions, this.engineOilDetails?.recommend?.viscosity);
      }
    }

    if (!engineOilDetails?.specs?.recommend) {
      this.recommendResultsNotFound = true;
    }

    this.recommend = engineOilDetails?.specs?.recommend || this.defaultRecommend;
    this.defaultRecomandedUnit = this.recommend.unit;

    if (this.recommend) {
      const finalRecommend = {
        ...this.defaultRecommend,
        ...Object.fromEntries(Object.entries(this.recommend).map(([key, value]) => (value !== '' ? [key, value] : [key, this.defaultRecommend[key]]))),
      };

      this.defaultRecommend = this.helperService.deepCopy(finalRecommend);
      this.recommend = this.helperService.deepCopy(finalRecommend);
    }

    this.apiQuery = {
      ...getDatalistAPIPayload,
      ...this.recommend,
    };
    this.getList();
  }

  getList() {
    this.isProcessing = true;
    // const payload = this.dynamicDialogConfig.data.getDatalistAPIPayload;
    // payload.partTypeId = 2412;
    this.httpService
      .getPartLookupModalDataList(this.apiQuery)
      .then((response) => {
        if (response) {
          this.listData = this.formateItems(response);
          this.noRecordFound = false;
          if (!this.listData?.length) {
            this.noRecordFound = true;
          }
          this.isProcessing = false;
        }
      })
      .catch((err) => {
        this.helperService.showToaster('error', err);
        this.isProcessing = false;
      });
  }
  setPricingBasedOnShopDetails(data: any) {
    const shopDetails = find(data?.shopDetails || [], { shopId: this.helperService.getCurrentShopId() });
    if (shopDetails) {
      return shopDetails?.price;
    } else {
      return data.price;
    }
  }

  async onSelectPartLookup(part: any, isChecked: boolean, isFromInventory = false, index) {
    this.disableInventoryOrder = false;
    this.onSelectProcessing = true;

    const selectedItemId = `${part.partId}-${index}`;

    // Handle the addition or removal of items
    if (isChecked) {
      // Add item logic
      if (isFromInventory) {
        const { formulation, viscosity } = part?.itemInfo?.fluidDetails;
        part = {
          ...part.itemInfo,
          itemId: part.itemInfo._id,
          amount: Number(part.itemInfo.cost) * Number(part.itemInfo.count),
          cost: Number(part.itemInfo.cost),
          price: this.setPricingBasedOnShopDetails(part.itemInfo),
          count: this.recommend.qty,
          description: part.itemInfo?.description ? part.itemInfo?.description : `Engine Oil - ${viscosity} - ${formulation}`,
          descriptionFR: part.itemInfo?.descriptionFR ? part.itemInfo?.descriptionFR : `Huile moteur - ${viscosity} - ${formulation}`,
        };
        if (this.isFlatRateItem) {
          part.flatRateAmount = part.amount;
          part.netSubTotal = part.amount;
        }
      }
      part.addedFromLookupDialog = true;
      this.selectedItem[selectedItemId] = part;
    } else {
      delete this.selectedItem[selectedItemId];
    }
    this.isProcessing = false;
    if (!Object.values(this.selectedItem)?.length) {
      this.disableInventoryOrder = true;
    }
  }

  copyText(text: string, index: number) {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        this.copiedIndex = index;
      })
      .catch((err) => {
        console.error('Failed to copy text: ', err);
      });
  }

  async addRepairOrder() {
    this.isProcessingAddingList = true;
    const items = Object.values(this.selectedItem);
    if (!items?.length) {
      this.isProcessingAddingList = false;
      this.helperService.showToaster('error', 'Please select at least one item');
      return;
    }

    try {
      const classificationMap = {};
      const classifications = await this.httpService.getCategoryByQuery({}, [
        ...items
          .map(({ itemInfo }: any) => {
            if (itemInfo?.taxonomy?.categoryId) {
              return {
                itemType: itemInfo.taxonomy.partTypeName === 'Tire' ? 'tire' : 'part',
                categoryId: itemInfo.taxonomy.categoryId,
                subCategoryId: itemInfo.taxonomy.subCategoryId,
                subSubCategoryId: itemInfo.taxonomy.partTypeId,
              };
            }

            return null;
          })
          .filter((category) => category),
      ]);

      if (classifications?.length) {
        classifications.forEach((classification: any) => {
          const { category, subCategory, subSubCategory } = classification;
          const id = this.createClassificationId(category?.categoryId, subCategory?.subCategoryId, subSubCategory?.subSubCategoryId);
          classificationMap[id] = classification;
        });
      }

      items.forEach((item: any) => {
        item.count = this.recommend.qty;
        const taxonomy = item?.itemInfo?.taxonomy || {};
        const id = this.createClassificationId(taxonomy?.categoryId, taxonomy?.subCategoryId, taxonomy?.partTypeId);
        const classification = classificationMap[id];
        if (classification?._id) {
          item.category = {
            _id: classification._id,
            name: [classification.category?.categoryName, classification.subCategory?.subCategoryName, classification.subSubCategory?.subSubCategoryName].filter((str) => str).join('/'),
            categoryId: classification.category?.categoryId,
            categoryName: classification.category?.categoryName,
            subCategoryId: classification.subCategory?.subCategoryId,
            subCategoryName: classification.subCategory?.subCategoryName,
            subSubCategoryId: classification.subSubCategory?.subSubCategoryId,
            subSubCategoryName: classification.subSubCategory?.subSubCategoryName,
          };
          item.salesCode = this.helperService.assignSalesCode(classification);
        }

        if (this.dataService.isSalesCodeEnabled) {
          item.tags = this.helperService.updateClassficationServiceItemTag(item.tags || [], { ...item, type: 'part' });
        }
      });
    } catch (err) {
      console.log(err);
    }

    this.postFluidDetailsPXGainSightEvent();

    this.dynamicDialogRef.close({
      confirm: true,
      partsTech: false,
      data: items,
    });
    this.isProcessingAddingList = false;
  }

  createClassificationId(categoryId: string, subCategoryId: string, subSubategoryId: string) {
    return [categoryId, subCategoryId, subSubategoryId].join('-');
  }

  handleClose(isSuccess: boolean = false) {
    this.dynamicDialogRef.close({ isSuccess });
  }

  onQuantityChange(value) {
    this.recommend.qty = value;
    this.apiQuery.quantity = value;
  }

  changeDecimal(value) {
    if (value) {
      return parseFloat(Number(value).toFixed(1));
    }
  }

  handleChange(type, item) {
    this.apiQuery[type] = item.value;
    this.recommend[type] = item.name;

    if (type === 'unit' && this.engineOilDetails.recommend.unit !== item.name) {
      const conversionFactor = item.name === 'Quarts' ? this.literToQuart : this.quartToLiter;
      this.engineOilDetails.recommend.qty = this.engineOilDetails.recommend.qty * conversionFactor;
      this.recommend.qty = '' + this.recommend.qty * conversionFactor;
      this.engineOilDetails.recommend.unit = item.name;
    }
    this.getList();
  }

  postFluidDetailsPXGainSightEvent() {
    if (this.dataService.isGainSightPXEnabled) {
      const items: any[] = Object.values(this.selectedItem);

      items.forEach((item) => {
        const fluidDetails = {
          formulation: item?.fluidDetails?.formulation,
          viscosity: item?.fluidDetails?.viscosity,
          quantity: this.recommend.qty,
          quantityUnit: this.recommend.unit,
          supplier: item?.supplier?.name,
          brand: item.brand ?? '',
          partName: item.title,
          partNumber: item?.partsTechDetails?.partNumber,
          cost: item.cost,
          roNumber: this.ro,
          motorRecommendedQuantity: this.engineOilDetails?.recommend?.qty,
          motorRecommendedQuantityUnit: this.engineOilDetails?.recommend?.unit,
          motorViscosityAndFormulationRecommendationTemp: item.temp,
          motorViscosityAndFormulationRecommendationOtherTempRanges: this.engineOilDetails?.recommendViscosity?.map(({ temp, formulation, viscosity }) => ({ temp, formulation, viscosity })),
        };

        this.helperService.postGainsightPXEvent('Fluid Details', fluidDetails);
      });
    }
  }

  formateItems(items: any[]) {
    if (!items.length) return;

    const formatedItems = items.map((item) => {
      // Check if the unit from the API does not match the currently selected unit
      if (item?.itemInfo?.fluidDetails?.unit !== this.recommend.unit) {
        if (this.recommend.unit === 'Litres' || this.recommend.unit === 'Liters') {
          // Convert from Quarts to Liters
          if (['quarts', 'quart'].includes(lowerCase(item?.itemInfo?.fluidDetails?.unit))) {
            item.itemInfo.countAvailable = item.itemInfo.countAvailable * this.quartToLiter;
          }
          item.itemInfo.unit = 'Litres';
        } else if (this.recommend.unit === 'Quarts') {
          // Convert from Liters to Quarts
          if (['litres', 'litre', 'liters', 'liter', 'Litres'].includes(lowerCase(item?.itemInfo?.fluidDetails?.unit))) {
            item.itemInfo.countAvailable = item.itemInfo.countAvailable * this.literToQuart;
          }
          item.itemInfo.unit = 'Quarts';
        }
      }
      return item;
    });
    return formatedItems;
  }

  ngOnDestroy() {
    this.companyLocalizationSubscription?.unsubscribe();
  }
}
